import Container from "@components/Container/Container";

/**
 * Component to render Description of DTA on homepage
 */
const DTADescription = (): React.ReactElement => {
  return (
    <Container
      rootClassName="flex flex-row justify-center px-0"
      data-testid="dta-description-component"
    >
      <div className="mb-15 mt-10 flex w-full flex-col justify-center text-center text-gray-850 md:pl-1 md:pr-3 lg:w-10/12 lg:flex-row lg:px-0 lg:pl-2">
        <div className="w-full lg:w-4/12 lg:pr-5">
          <h2 className="mb-6 px-3 text-left font-poppins text-4xl font-medium md:mb-7 md:px-2 md:text-6xl lg:mb-0 lg:px-0 lg:text-8xl lg:leading-tight">
            {"Design AI and Tech  "}
            <br className="inline md:hidden lg:inline" />
            {"Awards 2026 "}
          </h2>
        </div>

        <div className="text-md w-full px-3 text-left font-public-sans leading-[1.4] md:px-0 md:pl-2 lg:w-8/12">
          <p>
            Launched in October 2024, the Design AI and Tech Awards is a joint
            initiative by The Business Times (BT) and Singapore University of
            Technology and Design (SUTD), with SUTD also serving as the awards’
            knowledge partner.
          </p>

          <p>
            The award aims to recognise innovators across startups, SMEs, and
            large corporations who are leveraging design and technology to
            create impactful solutions for real-world business challenges. It
            also seeks to encourage a culture of continual innovation.
          </p>
        </div>
      </div>
    </Container>
  );
};

export default DTADescription;
